import React from 'react';

import type { INewPatientsData } from 'infrastructure/interfaces/';

interface IProps {
  data: INewPatientsData;
}

const ProviderColumn: React.FC<IProps> = ({ data }) => {
  return (
    <div>
      {data.doctor.title} {data.doctor.firstName} {data.doctor.lastName}
      {data.doctor.professionType ? ' - ' : ' '}
      {data.doctor.professionType}
    </div>
  );
};

export default ProviderColumn;
